import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ColumnControlSimpleComponent } from './column-control-simple/column-control-simple.component'
import { ColumnControlDateComponent } from './column-control-date/column-control-date.component'
import { I18nModule } from '@spartacus/core'
import { ColumnControlBaseComponent } from './base/column-control-base.component'
import { ColumnControlLinkComponent } from './column-control-link/column-control-link.component'
import { ColumnControlButtonComponent } from './column-control-button/column-control-button.component'
import { ColumnControlActionsComponent } from './column-control-actions/column-control-actions.component'
import { MaterialModule } from '../../../material.module'
import { ColumnControlUpdateButtonComponent } from './column-control-update-button/column-control-update-button.component'
import { ColumnTitleComponent } from './column-title/column-title.component'
import { ColumnControlInputInlineComponent } from './column-control-input-inline/column-control-input-inline.component'
import { FormsModule } from '@angular/forms'

@NgModule({
  declarations: [
    ColumnControlBaseComponent,
    ColumnControlSimpleComponent,
    ColumnControlDateComponent,
    ColumnControlLinkComponent,
    ColumnControlButtonComponent,
    ColumnControlActionsComponent,
    ColumnControlUpdateButtonComponent,
    ColumnTitleComponent,
    ColumnControlInputInlineComponent
  ],
  exports: [
    ColumnControlBaseComponent,
    ColumnControlSimpleComponent,
    ColumnControlDateComponent,
    ColumnControlLinkComponent,
    ColumnControlButtonComponent,
    ColumnControlActionsComponent,
    ColumnControlUpdateButtonComponent,
    ColumnTitleComponent,
    ColumnControlInputInlineComponent
  ],
  imports: [CommonModule, I18nModule, MaterialModule, FormsModule]
})
export class ColumnControlsModule {}
